import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

export const usePushPermission = () => {
  const { t } = useTranslation();

  const [isPermissionGranted, setIsPermissionGranted] = useState(
    Notification.permission === 'granted'
  );

  useEffect(() => {
    if (!('permissions' in navigator)) {
      return;
    }

    const subscribe = async () => {
      const status = await navigator.permissions.query({ name: 'notifications' });

      status.onchange = () => {
        setIsPermissionGranted(status.state === 'granted');
      };
    };

    subscribe();
  }, []);

  const requestPermission = useCallback(async () => {
    if (Notification.permission !== 'default') {
      toast(t('pushNotifications.browser-settings'));
      return;
    }

    await Notification.requestPermission();
  }, [t]);

  return useMemo(
    () => ({ isPermissionGranted, requestPermission }),
    [isPermissionGranted, requestPermission]
  );
};
